// extracted by css-extract-rspack-plugin
export default {"Wrapper":"WebGLHero-module__Wrapper__evKH2","Canvas":"WebGLHero-module__Canvas__F915P"};